function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "Audiences_svg__2_a",
  x1: "0%",
  x2: "100%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#F4F9FF"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#F8E7FF"
})), React.createElement("linearGradient", {
  id: "Audiences_svg__3_b",
  x1: "0%",
  x2: "100%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#8E9DFE"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#B97AD3"
})), React.createElement("linearGradient", {
  id: "Audiences_svg__4_c",
  x1: ".004%",
  x2: "99.996%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#7793FF"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#D576F0"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "url(#Audiences_svg__2_a)",
  d: "M8 0h34a8 8 0 018 8v34a8 8 0 01-8 8H8a8 8 0 01-8-8V8a8 8 0 018-8z"
}), React.createElement("path", {
  fill: "url(#Audiences_svg__3_b)",
  fillRule: "nonzero",
  d: "M42 0a8 8 0 018 8v34a8 8 0 01-8 8H8a8 8 0 01-8-8V8a8 8 0 018-8h34zm0 1H8a7 7 0 00-6.996 6.76L1 8v34a7 7 0 006.76 6.996L8 49h34a7 7 0 006.996-6.76L49 42V8a7 7 0 00-6.76-6.996L42 1z",
  opacity: 0.199
}), React.createElement("path", {
  fill: "url(#Audiences_svg__4_c)",
  d: "M28.242 27.028c.006.115.006.23 0 .343a5.863 5.863 0 01-1.248 4.022c-.09.268-.08.561.03.823 2.246.839 3.485 1.452 3.978 2.457.104.216.212.59.324 1.12A1 1 0 0130.348 37H19.651a1 1 0 01-.978-1.206c.112-.535.22-.91.325-1.126.493-1.001 1.732-1.616 3.998-2.467a1.226 1.226 0 00-.009-.836 5.837 5.837 0 01-1.229-3.994c-.093-1.815 1.283-3.363 3.073-3.457 1.79-.095 3.317 1.3 3.41 3.114zm-7.902.312v.057a4.534 4.534 0 00-.022.479l.003.13-.01.208.003.236a4.387 4.387 0 01-.91 2.163.884.884 0 00.022.617c.523.195.972.374 1.355.55-1.608.703-2.426 1.345-2.944 2.369a4.156 4.156 0 00-.254.669H14.21a1 1 0 01-.97-1.245c.057-.224.113-.392.167-.504.37-.75 1.299-1.211 2.998-1.85a.92.92 0 00-.007-.627 4.378 4.378 0 01-.921-2.995c-.07-1.362.961-2.523 2.304-2.594 1.343-.07 2.488.975 2.558 2.337zm14.182 0c.005.085.005.171 0 .257a4.397 4.397 0 01-.935 3.016.884.884 0 00.021.617c1.685.63 2.615 1.09 2.984 1.843.054.111.109.277.165.5a1 1 0 01-.97 1.245h-3.37a4.09 4.09 0 00-.25-.655l-.08-.153c-.524-.946-1.341-1.56-2.86-2.224l-.015-.005c.387-.18.844-.362 1.376-.562a.92.92 0 00-.007-.627 4.368 4.368 0 01-.895-2.137l.002-.237-.01-.21-.002.084a4.517 4.517 0 00-.017-.698c.035-1.272 1.03-2.323 2.305-2.39 1.343-.072 2.488.974 2.558 2.336zM25.001 13c11.603 0 11.986 3.367 11.998 9.014v1.17c-.006 2.75-.096 5.285-1.462 7.179l-.017-.008.017-.033.125-.3c.234-.606.367-1.25.392-1.905l.004-.328-.009-.193.004-.128-.006-.207c-.113-2.2-1.973-3.899-4.164-3.783a3.94 3.94 0 00-2.742 1.324 4.765 4.765 0 00-4.16-2.42l-.23.006-.232.018-.26.034a4.765 4.765 0 00-3.398 2.362 3.946 3.946 0 00-2.93-1.33l-.23.006-.21.017-.206.027c-1.847.295-3.238 1.862-3.333 3.74l-.005.201.003.117-.008.206.003.326c.024.65.156 1.29.386 1.892l.124.299.023.049-.017.009c-1.337-1.854-1.45-4.32-1.46-7.004v-1.534C13.023 16.29 13.529 13 25 13z"
}));

var SvgAudiences = function SvgAudiences(props) {
  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
};

export default SvgAudiences;